import { render, staticRenderFns } from "./ConfirmConsent.vue?vue&type=template&id=62e5a6e4&scoped=true"
import script from "./ConfirmConsent.vue?vue&type=script&lang=js"
export * from "./ConfirmConsent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmConsent.vue?vue&type=style&index=0&id=62e5a6e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e5a6e4",
  null
  
)

export default component.exports